import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, ErrorMessage, useFormik, FormikProvider } from "formik";
import { Form, Col, Container, Row, Card, CardBody, Button } from "react-bootstrap";
import * as Yup from "yup";
import ShowAlert from "../alert";
import { useNavigate } from "react-router";
import SwaranandhraService from "../../Services/SwaranandhraService";
import MasterService from "../../Services/MasterService";
import {maskMobile,maskEmail} from "../utils/commonFunctions";

export default function Forgotpassword() {
  const navigate = useNavigate(); const [data, setData] = useState(""); const [enb, setEnb] = useState(false); const [hide, setHide] = useState(false);

  const formik = useFormik({
    initialValues: {
      userid: "",
      password: "",
      conformPassword: "",
      otp: "",
    },
    validationSchema: Yup.object().shape({
      otp: Yup.string().required("Required"),
      password: Yup.string().required("Required").min(10, "At least 10 characters.").matches(/[a-z]/, "Ateast one lowercase letter.").matches(/[A-Z]/, "Ateast one uppercase letter.").matches(/\d/, "Ateast one number.").matches(/[@$!%*?&#]/, "Ateast one special character."),
      conformPassword: Yup.string().required("Required").oneOf([Yup.ref("password"), null], "Passwords must match."),
    }),
    onSubmit: (values) => {
      const params = { type: "verifyotp", userId: values.userid, password: values.password, conformPassword: values.conformPassword, otp: parseInt(values.otp), };
      SwaranandhraService.getVerifyotp(params).then((res) => {
        if (res?.data.SCODE == "01") {
          ShowAlert(res.data.SDESC, "success").then(() => { navigate("/SwarnandhraLogin"); });
        } else if (res?.data.SCODE == "02") {
          ShowAlert(res.data?.SDESC, "warning");
        } else {
          ShowAlert("Invalid!", "warning");
        }
      });
    },
  });

  const getLoginDetails = () => {
    if (!formik.values.userid) {
      ShowAlert("Enter User id", "warning");
      return;
    }

    const params = { type: "userdata", userId: formik.values.userid, };
    MasterService.getLoginDetails(params).then((res) => {
      if (res?.data?.SCODE === "01") {
        setHide(true);
        setData(res?.data?.SDESC);
      } else {
        setHide(false); ShowAlert(res?.data?.SCODE === "02" ? res?.data?.SDESC : "User id not found", "warning"); setData("");
      }
    });
  };

  const getOtp = () => {
    const params = { userId: formik.values.userid };
    SwaranandhraService.getOtp(params).then((res) => {
      if (res?.data?.SCODE === "01") {
        ShowAlert(res?.data?.SDESC, "success").then(() => {
          setEnb(true); setHide(false); formik.setFieldValue("otp", ""); formik.setFieldValue("conformPassword", ""); formik.setFieldValue("password", "");
        });
      }else {
        ShowAlert(res?.data?.SDESC,"warning");
      }
    });
  };




  return (
    <>
      <section id="">
        <Container fluid>
          <Row className=" ">
            <div className="d-block d-sm-flex justify-content-between shadow logo-all px-3"> <div className="d-flex">  <div><img src="images/swarna-logo.svg" className="img-fluid w-75" alt="Swarna Andhra logo" /></div></div> </div>
          </Row>
        </Container>
      </section>
      <Container fluid style={{ width: "60%" }}>
        <Row className="align-items-center mb-3">
          <Col> <div className="sa-title"> <h2> Forgot <span>Password</span> </h2> </div> </Col>
          <Col xs="auto"> <Button onClick={() => navigate("/SwarnandhraLogin")} className="mt-4 btn btn-dark btn-sm"> Back to Login </Button> </Col>
        </Row>
      </Container>

      <Container fluid style={{ width: "60%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Card className="mb-5 rounded-2 border" style={{ borderColor: "#ccc", boxShadow: "none" }}>
              <CardBody>
                {enb && (
                  <Row>
                    <Col className="text-end"> <Button onClick={() => { setEnb(false); setHide(true); }} className="mt-4 btn btn-secondary btn-sm" > Back </Button> </Col>
                  </Row>
                )}

                <Row className="d-flex justify-content-center">
                  <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4">
                    <Row>
                      <Col xs={8}> <Form.Label> Username </Form.Label> <Field name="userid" type="text" placeholder="Username" handleChange={(e) => { formik.handleChange(e); }} disabled={enb} className="form-control" /> </Col>
                      <Col xs={4} className="d-flex align-items-end"> <Button variant="warning" type="button" disabled={enb} onClick={getLoginDetails} className="w-100"> Go </Button> </Col>
                    </Row>
                  </Col>
                </Row>
                {hide && (
                  <>
                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4">
                        <Form.Label> Mobile number </Form.Label>
                        <Field name="mobile_number" className="form-control" type="text" placeholder="Mobile number" value={maskMobile(data?.phone)}disabled={true} />
                      </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Form.Label> Mail ID </Form.Label> <Field name="mailid" type="text" className="form-control" placeholder="Mail ID" value={maskEmail(data?.email)} disabled={true} /> </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Form.Label> Designation </Form.Label> <Field name="designation" type="text" className="form-control" placeholder="Designation" value={data?.uname} disabled={true} /> </Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Button type="button" onClick={getOtp} className="btn btn-success w-100"> Get OTP </Button> </Col>
                    </Row>
                  </>
                )}
                {enb && (
                  <>
                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Form.Label> Enter OTP <span className="text-danger">*</span> </Form.Label> <Field name="otp" className="form-control" type="text" placeholder="OTP" /> <ErrorMessage name="otp" className="text-error" component="div" /> </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Form.Label> Enter New Password <span className="text-danger">*</span> </Form.Label> <Field className="form-control" name="password" type="password" placeholder="New Password" /> <ErrorMessage name="password" className="text-error" component="div" /> </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Form.Label> Confirm Password <span className="text-danger">*</span> </Form.Label> <Field className="form-control" name="conformPassword" type="password" placeholder="Confirm Password" /> <ErrorMessage name="conformPassword" className="text-error" component="div" /> </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                      <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12} className="mb-4"> <Button type="submit" className="btn btn-success w-100"> Update </Button> </Col>
                    </Row>
                  </>
                )}
              </CardBody>
            </Card>
          </Form>
        </FormikProvider>
      </Container>
    </>
  );
}
